export default "__VITE_ASSET__60083e51__"